import { Injectable } from '@angular/core';
import { StatesService } from '@services/states.service';
import { SourceFilterOptionsLoader } from '@shared/dataview/options/filter-options.registry';
import { SelectListItem } from '@shared/models/select-list-item';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StatesOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'states';

  load(): Observable<SelectListItem[]> {
    return of(StatesService.getStates().map(state => ({ name: state.name ?? state.value, value: state.value })));
  }
}
